import { render, staticRenderFns } from "./InstructionView.vue?vue&type=template&id=749114d8&scoped=true&"
import script from "./InstructionView.vue?vue&type=script&lang=js&"
export * from "./InstructionView.vue?vue&type=script&lang=js&"
import style0 from "./InstructionView.vue?vue&type=style&index=0&id=749114d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749114d8",
  null
  
)

export default component.exports